import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")

import {   getCurrentInstance, ref, Ref, reactive, computed } from 'vue'
import { formatNumber } from '@/utils/index'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'POST/socials/changes': fetchList,
} = Api

const searchConfig = ref([
  {
    type: "TIME",
    label: "时间1",
    value: '',
    upKey: 'dateOne',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "时间2",
    value: '',
    upKey: 'dateTwo',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
])

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


// 合并行
const userIds: any = computed(() => MI_tableData.value.map((_user: any) => _user.userId))
const objectSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => { 
  
  if (columnIndex < 5 ) {
    if(rowIndex === 0) {
      return {
        rowspan: userIds.value.lastIndexOf(row.userId) + 1,
        colspan: 1,
      }
    } else if(
      rowIndex + 1 < MI_tableData.value.length &&
      MI_tableData.value[rowIndex].userId !== MI_tableData.value[rowIndex - 1].userId &&
      MI_tableData.value[rowIndex].userId !== MI_tableData.value[rowIndex + 1].userId 
    ) {
      return {
        rowspan: 1,
        colspan: 1,
      }
    } else if(
      rowIndex + 1 < MI_tableData.value.length &&
      MI_tableData.value[rowIndex].userId !== MI_tableData.value[rowIndex - 1].userId &&
      MI_tableData.value[rowIndex].userId === MI_tableData.value[rowIndex + 1].userId
    ){
      let _rowspan = userIds.value.lastIndexOf(row.userId) - rowIndex
      return {
        rowspan: _rowspan + 1,
        colspan: 1,
      }
    } else if(
      rowIndex + 1 === MI_tableData.value.length &&
      row.userId !== MI_tableData.value[rowIndex - 1].userId 
    ){
      return {
        rowspan: 1,
        colspan: 1,
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0,
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "mb-10 mt-10",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/insurance'})))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "社保异动" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              title: true,
              searchConfig: searchConfig.value,
              initSearch: false
            }, {
              onSearchFn: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)($event, {} , 1)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "span-method": objectSpanMethod
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "英文名",
          prop: "alias",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          width: "250",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "参保日期",
          prop: "participationDate",
          width: "105"
        }),
        _createVNode(_component_el_table_column, {
          label: "停缴日期",
          prop: "unPaymentDate",
          width: "105"
        }),
        _createVNode(_component_el_table_column, {
          label: "缴纳时间",
          prop: "payDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "单位养老保险",
          align: "right",
          prop: "companyEndowment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人养老保险",
          align: "right",
          prop: "personalEndowment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位医疗保险",
          align: "right",
          prop: "companyMedical",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人医疗保险",
          align: "right",
          prop: "personalMedical",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位工伤保险",
          align: "right",
          prop: "companyInjury",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人工伤保险",
          align: "right",
          prop: "personalInjury",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位生育保险",
          align: "right",
          prop: "companyMaternity",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人生育保险",
          align: "right",
          prop: "personalMaternity",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位失业保险",
          align: "right",
          prop: "companyUnemployment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人失业保险",
          align: "right",
          prop: "personalUnemployment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位公积金",
          align: "right",
          prop: "companyHousing",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人公积金",
          align: "right",
          prop: "personalHousing",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "总计",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "total",
          width: "110",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, ],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})